import merge from 'lodash/merge';
import { TFunction } from 'i18next';

import { getDefaultAtpConfig, getTemplateConfig } from './cfg.default';
import { ApplyBoundEnum } from '@Policy/utils/types';
import { getDefaultRiskAiFilter } from './cfg.exchange';
import { PolicyTypeEnum } from '@Policy/utils/constants';

const cfg = {
  policySubType: 0,
  policyType: 21,

  tmFileblockings: {
    fbActionType: 220,
  },
  tmVirusscans: {
    vsAdditionalThreatsActionType: 220,
    vsMaliciousActionType: 220,
    vsPackersActionType: 220,
    vsRansomwareActionType: 220,
    vsVirusesActionType: 220,
    vsWormsTrojansActionType: 220,
  },
  tmWebthreatprotections: {
    wtpActionType: 220,
    wtpActionBlockedUrl: 220,
    wtpUrlcvEnabled: 1,
    wtpApprovedHeaderList: '',
    wtpExtractAttachmentUrl: 1,
    wtpApplyBound: ApplyBoundEnum.all,
  },
  tmAntispamfilters: {
    asBlockedHeaderEnabled: 0,
    asBlockedHeaderRuleList: '',
    asActionBec: 220,
    asActionBlockedSender: 220,
    asActionMalicious: 220,
    asActionOthers: 221,
    asActionPhish: 220,
    asActionRansome: 220,
    asActionScam: 220,
    asApprovedHeaderList: '',
    wsNotifyRecipientActionType: 220,
  },
  tmDdafilters: {
    ddaActionHighRisk: 220,
    ddaActionMediumRisk: 220,
  },
};
export function getGmailTemplateConfig(
  t: TFunction<'translation'>,
  featureShow: Record<string, boolean | number>,
  accountEmail: string | undefined
) {
  const coverI18nKeys = [
    'policy.policyTemplate.GMAIL.tmAntispamfilters.ntfWritingStyleExpectedSenderSubject',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.ntfWritingStyleExpectedSenderMessage',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.tfWritingStyleToExpectedSenderFeedbackMessage',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.ntfWritingStyleAdministratorSubject',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.ntfWritingStyleAdministratorMessage',
  ];
  const ntfI18nReplaceKeys = [
    'policy.policyTemplate.GM.tmAntispamfilters.notification.ntfAdminMessage',
    'policy.policyTemplate.GM.tmAntispamfilters.notification.ntfAdminSubject',
    'policy.policyTemplate.GM.tmAntispamfilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.GM.tmAntispamfilters.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.GM.tmFileblockings.notification.ntfAdminMessage',
    'policy.policyTemplate.GM.tmFileblockings.notification.ntfAdminSubject',
    'policy.policyTemplate.GM.tmFileblockings.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.GM.tmFileblockings.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.GM.tmVirusscans.notification.ntfAdminMessage',
    'policy.policyTemplate.GM.tmVirusscans.notification.ntfAdminSubject',
    'policy.policyTemplate.GM.tmVirusscans.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.GM.tmVirusscans.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.GM.tmWebthreatprotections.notification.ntfAdminMessage',
    'policy.policyTemplate.GM.tmWebthreatprotections.notification.ntfAdminSubject',
    'policy.policyTemplate.GM.tmWebthreatprotections.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.GM.tmWebthreatprotections.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.GM.tmDdafilters.notification.ntfAdminMessage',
    'policy.policyTemplate.GM.tmDdafilters.notification.ntfAdminSubject',
    'policy.policyTemplate.GM.tmDdafilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.GM.tmDdafilters.notification.ntfInternalRecipientSubject',
  ];
  const tempConfig = getDefaultAtpConfig();
  merge(tempConfig, cfg);
  const riskAi = getDefaultRiskAiFilter(t, PolicyTypeEnum.Gmail, featureShow);
  merge(tempConfig, riskAi);
  console.log('tempConfig', tempConfig);
  console.log(
    'getTemplate',
    getTemplateConfig(
      t,
      tempConfig,
      accountEmail,
      coverI18nKeys,
      ntfI18nReplaceKeys
    )
  );
  return getTemplateConfig(
    t,
    tempConfig,
    accountEmail,
    coverI18nKeys,
    ntfI18nReplaceKeys
  );
}
